import gqlTagGira from 'graphql-tag';

export const TEAM_FRAGMENT = gqlTagGira`
    fragment jiraBusinessTeamFieldFragment on JiraTeamViewField {
        fieldId
        selectedTeam {
            jiraSuppliedName
            jiraSuppliedTeamId
            jiraSuppliedIsVerified @include(if: $includeIsVerifiedInTeamFragment)
        }
    } 
`;
